import React from "react";
import LayoutFr from "../../components/LayoutFr";
import HeroFr from "./HeroFr";
import IntroFr from "./IntroFr";
import MywhyFr from "./MywhyFr";
import MywhyTop from "./MywhyTop";


function AccueilFr() {
	
	return (
		<LayoutFr>
			<HeroFr />
			<MywhyTop />
			<IntroFr />
			<MywhyFr />
		</LayoutFr>
	);
}

export default AccueilFr;
